import moment from 'moment';

export type DateCeilType = {
  date: number; // 开始时间
  startTime: number;
  endTime: number; // 结束时间
  content: string | number;
  disabled: boolean;
  selected: boolean;
  isToday: boolean;
  weekday: number;
  month: number;
  isNotice?: boolean;
  isTask?: boolean;
}

const getOffsetAry = (day: DateCeilType, operate: 'subtract' | 'add') => {
  const offsetFn = {
    subtract: (weekday: number) => {
      if (weekday === 6) {
        return 0;
      }

      return weekday + 1;
    },
    add: (weekday: number) => {
      if (weekday === 6) {
        return 6;
      }

      return 5 - weekday;
    }
  };

  const res = [];

  if (day.weekday === 6 && operate === 'subtract') {
    return [];
  }
  if (day.weekday === 5 && operate === 'add') {
    return [];
  }
  let offset = offsetFn[operate](day.weekday);
  let i = 1;
  const startDayMoment = moment(day.date);

  while (offset--) {
    const offsetMoment = startDayMoment[operate](i, 'day');
    const date = offsetMoment.valueOf();
    const endTime = offsetMoment.endOf('d').valueOf();
    const weekday = offsetMoment.weekday();
    const day = offsetMoment.format('D');
    const month = offsetMoment.month();
    const dateCeil = {
      weekday,
      date,
      startTime: date,
      endTime,
      content: day,
      disabled: true,
      selected: false,
      isToday: false,
      month
    };

    if (operate === 'subtract') {
      res.unshift(dateCeil);
    }

    if (operate === 'add') {
      res.push(dateCeil);
    }

    i++;
  }

  return res;
};

export const getCurMonthAry = (baseTime?: number) => {
  const momentInstance = baseTime ? moment(baseTime) : moment();
  const month = momentInstance.month();
  const daysInMonth = momentInstance.daysInMonth();
  const format = momentInstance.format('YYYY-MM');
  let i = 1;
  const res = [];
  while (i <= daysInMonth) {
    const date = moment(format + i).valueOf();
    const endTime = moment(format + i).endOf('d').valueOf();
    const weekday = moment(format + i).weekday();

    res.push({
      weekday,
      startTime: date,
      endTime,
      date,
      content: i,
      disabled: false,
      selected: false,
      isToday: false,
      month
    });
    i++;
  }

  return [
    ...getOffsetAry(res[0], 'subtract'),
    ...res,
    ...getOffsetAry(res[res.length - 1], 'add')
  ];
};

export const getTodayTime = () => {
  return moment(moment().format('YYYY-MM-DD')).valueOf();
};

export const getHintCeilAry = (
  data: DateCeilType[],
  selectedDate: number,
  noticeList: number[] = [],
  taskList: number[] = [],
  today: number
) => {
  return data.map((el) => {
    el.selected = el.date === selectedDate;
    el.isNotice = noticeList.findIndex(_el => el.date === _el) > -1;
    el.isTask = taskList.findIndex(_el => el.date === _el) > -1;
    el.isToday = moment(el.date).isSame(today, 'date');
    return el;
  });
};
